<template>
  <div class="blanking" :style='"height:" + height'></div>
</template>
<script>
export default {
  name: 'Blanking',
  props: {
    height: {
      type: String,
      default: '10px'
    }
  }
}
</script>
<style scoped lang="stylus">
  @import '~@/style/variable.styl'
  .blanking
    background-color $color-gray-ll
</style>



// WEBPACK FOOTER //
// src/base-component/blanking/index.vue